/***
 * Created on 2023/11/16
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/

import React from 'react';
import ModalDialog from "../modal_dialog/modalDialog";
import {useTranslation} from "react-i18next";

function CreateAccountNoticeDialog({showModal, closeModal, dispatch}) {
    const { t } = useTranslation();

    return (
        <ModalDialog title={t('@Create Account@')} submitText={t('@Create@')} showModal={showModal} closeModal={closeModal} submitAction={() => dispatch('gdpr')}>
            <div className="dialog-content">
                <p>{t('@You have not created an account with this social network account. Go to the QNAP Account creation page to sign up.@')}</p>
            </div>
        </ModalDialog>
    );
}

export default CreateAccountNoticeDialog;